import { RuleObject } from 'antd/lib/form';
import i18n from '~/i18n';
import { basicValidation } from './basicValidation';

export type Validator = RuleObject['validator'];

const emailValidation: Validator = basicValidation((rule, value, callback) => {
  try {
    const pattern = new RegExp(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      'i'
    );
    if (!pattern.test(value)) {
      throw new Error(i18n.t('Invalid email', { ns: 'validation' }));
    }
    callback();
  } catch (err) {
    console.log((err as any).message as string);
    callback((err as any).message as string);
  }
});

export default emailValidation;
